import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { buildBiqPageContext } from '../utils/biqPageContext';

const BiqPageExtrasContext = createContext(null);

export function BiqPageContextProvider({ children, searchOverride }) {
  const { pathname, search: locationSearch } = useLocation();
  // /map keeps its filters in state, not the URL; DashboardLayout passes them in.
  const search = searchOverride ?? locationSearch;
  const [extras, setExtras] = useState(null);
  const setPageExtras = useCallback((next) => {
    setExtras(next);
  }, []);
  // Separate slot so a map's selected hazard never clobbers the page's own extras.
  const [hazard, setHazard] = useState(null);
  const setPageHazard = useCallback((next) => {
    setHazard(next);
  }, []);

  const pageContext = useMemo(
    () => buildBiqPageContext(pathname, search, extras, hazard),
    [pathname, search, extras, hazard],
  );

  const value = useMemo(
    () => ({ pageContext, setPageExtras, setPageHazard }),
    [pageContext, setPageExtras, setPageHazard],
  );

  return (
    <BiqPageExtrasContext.Provider value={value}>
      {children}
    </BiqPageExtrasContext.Provider>
  );
}

export function useBiqPageContext() {
  return useContext(BiqPageExtrasContext);
}
